<template>
  <filter-template @submit="filter()">
    <v-row class="flex-grow-0 flex-shrink-0">
      <v-col
        cols="12"
        sm12
      >
        <div
          class="headerSubtitle1"
        >
          Dados da pesquisa
        </div>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="5"
      >
        <v-menu
          ref="menuMinDate"
          v-model="menuMinDate"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="computedInitialDateFormatted"
              label="Data inicial"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              outlined
              :rules="[requiredRule, initialFinalDateRule('Data final', 'menor')]"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="payload.minDate"
            scrollable
            @input="menuMinDate = false"
          />
        </v-menu>
      </v-col>
      <v-col
        cols="12"
        sm="0"
        md="2"
        class="d-flex justify-center align-center align-self-center body1 secondary200"
        style="margin-bottom: 24px"
      >
        Até
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="5"
      >
        <v-menu
          ref="menuMaxDate"
          v-model="menuMaxDate"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="computedFinalDateFormatted"
              label="Data final"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              outlined
              :rules="[requiredRule, initialFinalDateRule('Data inicial', 'maior'),
                       intervalExceeded()]"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="payload.maxDate"
            scrollable
            @input="menuMaxDate = false"
          />
        </v-menu>
      </v-col>
    </v-row>
  </filter-template>
</template>

<script>
import FilterTemplate from 'Arch/components/crud/components/FilterTemplate.vue';
import FilterMixin from 'Arch/components/crud/crud-mixins/FilterMixin';
import RulesMixin from 'Arch/mixins/RulesMixin';
import Moment from 'moment';

export default {
  name: 'UsageReportFilter',
  components: { FilterTemplate },
  mixins: [FilterMixin, RulesMixin],
  data() {
    return {
      menuMinDate: false,
      menuMaxDate: false,
      payload: {
        minDate: null,
        maxDate: null,
      },
    };
  },
  computed: {
    computedInitialDateFormatted() {
      return this.formatDate(this.payload.minDate);
    },
    computedFinalDateFormatted() {
      return this.formatDate(this.payload.maxDate);
    },
  },
  created() {
    const date = Moment(new Date());
    const dateFormat = 'YYYY-MM-DD';
    this.payload.maxDate = date.format(dateFormat);
    this.payload.minDate = date.subtract(1, 'M').format(dateFormat);
  },
  methods: {
    initialFinalDateRule(fieldCompared, mustBe) {
      const { maxDate, minDate } = this.payload;

      return (Moment(minDate).isSameOrBefore(maxDate))
        || `O valor deste campo deve ser ${mustBe} ou igual ao valor do campo "${fieldCompared}"`;
    },

    intervalExceeded() {
      const days = Moment(this.payload.maxDate).diff(Moment(this.payload.minDate), 'days');
      return (days <= 90)
        || 'O intervalo máximo entre “Data inicial” e “Data final” não pode exceder 90 dias.';
    },
    formatDate(date) {
      if (date) {
        return Moment(date).format('DD/MM/YYYY');
      }
      return null;
    },
  },
};
</script>
